export default "__VITE_ASSET__9ea33adf__"